export default __webpack_public_path__ + "static/media/Niyosha Teacher.9702010f.mp4";